module.exports = __webpack_public_path__ + "img/cambodia.f37649a6.svg";